import React from "react";
import {
  Typography,
  Grid,
  Container,
  Card,
  CardActionArea,
} from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import Icon from "../../components/Icon";
const useStyles = makeStyles(() => ({
  carStyle: {
    border: "1px solid #A5A5A5 !important",
  },
  cardTitle: {
    fontSize: "25px !important",
    fontStyle: "Poppins  !important",
    lineHeight: "37.5px  !important",
    marginTop: "20px !important",
  },
}));
export default function LoansFPO() {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const buttons = [
    {
      label: t("See all lenders"),
      type: "see-all-lenders",
      route: "/fpo/all-lenders",
    },
    {
      label: t("My Proposals"),
      type: "loan-received",
      route: "/fpo/loan-proposals",
    },
    {
      label: t("Loan documents"),
      type: "loan-documents",
      route: "/fpo/loan-documents",
    },
    {
      label: t("My Loans"),
      type: "my-loan",
      route: "/fpo/my-loans",
    },
  ];
  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <Grid container spacing={2} sx={{ marginTop: "20px" }}>
          {buttons.map((button, index) => (
            <Grid
              item
              xs={12}
              key={index}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Card
                variant="outlined"
                style={{ width: "100%", height: 162 }}
                className={classes.carStyle}
              >
                <CardActionArea
                  onClick={() => navigate(button.route)}
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon type={button.type} />
                  <div>
                    <Typography className={classes.cardTitle}>
                      {button.label}
                    </Typography>
                  </div>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
}
